var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKg = function SvgKg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m17.868 12-2.398 1.128 1.277 2.322-2.604-.498-.33 2.63L12 15.649l-1.813 1.935-.33-2.63-2.604.497 1.277-2.322L6.13 12l2.398-1.128L7.252 8.55l2.604.498.33-2.63 1.813 1.934 1.814-1.935.33 2.63 2.604-.497-1.277 2.322L17.868 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 15.651a3.652 3.652 0 1 0 0-7.304 3.652 3.652 0 0 0 0 7.304Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M10.175 12a2.64 2.64 0 0 0-.26.013c.002.506.185.97.488 1.329a3.66 3.66 0 0 1 .705-1.168 2.593 2.593 0 0 0-.933-.174ZM11.299 13.967a2.082 2.082 0 0 0 1.404 0A2.61 2.61 0 0 0 12 12.749a2.61 2.61 0 0 0-.702 1.218ZM13.808 10.957a2.086 2.086 0 0 0-3.615 0 3.628 3.628 0 0 1 1.808.491 3.629 3.629 0 0 1 1.807-.49ZM12.894 12.174c.303.338.544.734.705 1.168.302-.36.485-.822.489-1.328a2.593 2.593 0 0 0-1.194.16Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgKg;